const ACCOUNT_MANAGERS_BASE_KEY = "sales-intelligence/account-managers";

export const accountManagerQueryKeys = {
    all() {
        return [ACCOUNT_MANAGERS_BASE_KEY] as const;
    },
};
